import { Component, OnInit, Input } from '@angular/core';
import { NgIf } from '@angular/common';

@Component({
    selector: 'seo-detail',
    templateUrl: './seo-detail.component.html',
    styleUrls: ['./seo-detail.component.scss'],
    standalone: true,
    imports: [NgIf],
})
export class SeoDetailComponent implements OnInit {
  @Input()
  hotelStatic: any;

  constructor() {}

  ngOnInit() {}
}
